import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "page-container" };
import { menuOptions } from "@/utils/constants";
import { computed, h, ref } from "vue";
import NoTargetShowRouterLink from "@/components/common/NoTargetShowRouterLink.vue";
import HeadRightToolBar from "@/components/combination/HeadRightToolBar.vue";
import CustomSVG from "@/components/custom/CustomSVG.vue";
import { NIcon } from "naive-ui";
import { useRoute } from "vue-router";
import { useRouter } from "vue-router";
import { useStore } from "@/store";
export default /*@__PURE__*/ _defineComponent({
    __name: 'menuLayout',
    setup: function (__props) {
        var _this = this;
        var _a;
        var store = useStore();
        var route = useRoute();
        var router = useRouter();
        var activeKey = ref("");
        var menuContentContainerRef = ref(null);
        window.menuContentContainerRef = menuContentContainerRef;
        // const menuOptions: MenuOption[] = [
        //   {
        //     label: "博客中控后台",
        //     name: "console-home",
        //     key: "blog-admin",
        //   },
        //   {
        //     label: "文章发布",
        //     key: "post-release",
        //     name: "post-release", // 路由名称
        //   },
        //   {
        //     label: "文章管理",
        //     key: "post-manager",
        //     name: "post-manager",
        //   },
        //   {
        //     label: "随计发布",
        //     key: "note-release",
        //     name: "note-release",
        //   },
        //   {
        //     label: "随记管理",
        //     key: "note-manager",
        //     name: "note-manager",
        //   },
        //   {
        //     label: "网站概览",
        //     key: "dashboard",
        //     name: "dashboard",
        //   },
        // ];
        var collapsed = computed({
            get: function () {
                return store.isMenuCollapsed;
            },
            set: function (value) {
                store.setMenuCollapsed(value);
            },
        });
        function renderMenuLabel(option) {
            if ("name" in option && typeof option.name === "string") {
                var label_1 = option.label;
                if (option.key === "blog-admin") {
                    return h(NoTargetShowRouterLink, {
                        style: {
                            fontSize: "1.2rem",
                            fontWeight: "bolder",
                            color: "var(--theme-color)",
                            marginLeft: "0.7rem",
                        },
                        to: {
                            name: menuOptions[1].name,
                        },
                        class: "logo-title",
                    }, 
                    // label // 不直接使用 label 的字符串而是包装为 span 进行渲染，否则传入非函数式内容会引发警告说性能下降
                    {
                        default: function () {
                            return h("span", // 使用span元素
                            { class: ["menu-item-label", "logo-title"] }, // 给span添加类名
                            label_1 // 将label作为span的内容
                            );
                        },
                    });
                }
                return h(NoTargetShowRouterLink, {
                    to: {
                        name: option.name,
                    },
                }, 
                // label // 直接写 option.label as string 不行，为什么？
                {
                    default: function () {
                        return h("span", // 使用span元素
                        { class: "menu-item-label" }, // 给span添加类名
                        label_1 // 将label作为span的内容
                        );
                    },
                });
            }
            return option.label;
        }
        // 渲染菜单图标，返回菜单子项的 iconVNode，如果没有则返回默认的 BookmarkOutline 图标
        function renderMenuIcon(option) {
            var _a;
            // if (option.key === "blog-admin") {
            //   return h(
            //     "i",
            //     {
            //       class: ["fa-solid", "fa-terminal", "logo-icon"],
            //       style: {
            //         fontSize: "1.8rem",
            //         color: "var(--theme-color)",
            //       },
            //     },
            //     { default: () => h(Terminal) }
            //   );
            // } else if (option.key === "post-release") {
            //   return h(NIcon, null, { default: () => h(BookmarkOutline) });
            // } else if (option.key === "post-manager") {
            //   return h(NIcon, null, { default: () => h(BookmarkOutline) });
            // } else if (option.key === "note-release") {
            //   return h(NIcon, null, { default: () => h(BookmarkOutline) });
            // } else if (option.key === "note-manager") {
            //   return h(NIcon, null, { default: () => h(BookmarkOutline) });
            // } else if (option.key === "dashboard") {
            //   return h(NIcon, null, { default: () => h(BookmarkOutline) });
            // }
            // return h(NIcon, null, { default: () => h(BookmarkOutline) });
            return (((_a = menuOptions.find(function (obj) { return obj.key === option.key; })) === null || _a === void 0 ? void 0 : _a.iconVNode) ||
                h(NIcon, null, { default: function () { return h(CustomSVG, { icon: "BookmarkOutline" }); } }));
        }
        function expandIcon() {
            return h(NIcon, null, {
                default: function () { return h(CustomSVG, { icon: "CaretDownOutline" }); },
            });
        }
        // Watch route changes to update active menu item
        activeKey.value = route.name;
        store.setPageName((_a = menuOptions.find(function (obj) { return obj.name === route.name; })) === null || _a === void 0 ? void 0 : _a.label);
        // 菜单选择处理器
        var handleMenuSelect = function (key, item) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (item.key === "blog-admin") {
                    // // 立即阻止默认路由行为
                    // await nextTick();
                    activeKey.value = menuOptions[1].key;
                    router.push({ name: menuOptions[1].name });
                    // const targetRoutePath = router.resolve({ name: item.name as string }).href;
                    // tools.jumpToLocalWithoutRouter(
                    //   targetRoutePath.startsWith(consoleURLPrefix)
                    //     ? targetRoutePath.slice(consoleURLPrefix.length)
                    //     : targetRoutePath
                    // );
                }
                else {
                    activeKey.value = key;
                    // const targetRoutePath = router.resolve({ name: item.name as string }).href;
                    // tools.jumptoLocal(
                    //   targetRoutePath.startsWith(consoleURLPrefix)
                    //     ? targetRoutePath.slice(consoleURLPrefix.length)
                    //     : targetRoutePath
                    // );
                    router.push({ name: item.name });
                }
                store.setPageName(item.label);
                return [2 /*return*/];
            });
        }); };
        return function (_ctx, _cache) {
            var _component_n_menu = _resolveComponent("n-menu");
            var _component_n_layout_sider = _resolveComponent("n-layout-sider");
            var _component_router_view = _resolveComponent("router-view");
            var _component_n_layout = _resolveComponent("n-layout");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_n_layout, { "has-sider": "" }, {
                    default: _withCtx(function () { return [
                        _createVNode(_component_n_layout_sider, {
                            bordered: "",
                            "collapse-mode": "width",
                            "collapsed-width": 64,
                            width: 250,
                            collapsed: collapsed.value,
                            "show-trigger": "",
                            onCollapse: _cache[0] || (_cache[0] = function ($event) { return (collapsed.value = true); }),
                            onExpand: _cache[1] || (_cache[1] = function ($event) { return (collapsed.value = false); }),
                            class: "menu-sider"
                        }, {
                            default: _withCtx(function () { return [
                                _createVNode(_component_n_menu, {
                                    collapsed: collapsed.value,
                                    "collapsed-width": 64,
                                    "collapsed-icon-size": 22,
                                    options: _unref(menuOptions),
                                    "render-label": renderMenuLabel,
                                    "render-icon": renderMenuIcon,
                                    "expand-icon": expandIcon,
                                    "default-value": activeKey.value,
                                    class: "custom-menu",
                                    "onUpdate:value": handleMenuSelect
                                }, null, 8, ["collapsed", "options", "default-value"])
                            ]; }),
                            _: 1
                        }, 8, ["collapsed"]),
                        _createVNode(_component_n_layout, { class: "content-layout" }, {
                            default: _withCtx(function () { return [
                                _createVNode(HeadRightToolBar),
                                _createElementVNode("div", {
                                    class: "content-container",
                                    ref_key: "menuContentContainerRef",
                                    ref: menuContentContainerRef
                                }, [
                                    _createVNode(_component_router_view)
                                ], 512)
                            ]; }),
                            _: 1
                        })
                    ]; }),
                    _: 1
                })
            ]));
        };
    }
});
